















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'commonIconBtn'
})
export default class extends Vue {
  @Prop({type: String}) public name!: string;
  @Prop({type: Boolean, default: false}) public disabled!: boolean;
  @Prop({type: String, default: 'primary'}) public type!: string;
  @Prop() public iconReverse!: boolean;

  public handleBtnClick() {
    if (this.disabled) {
      return;
    }
    this.$emit('handle-btn-click');
  }
}
